<template>
  <div class="floating-ticket-widget">
    <!-- Widget de ticket (sempre presente, mas invisível) -->
    <TicketWidget 
      ref="ticketWidget"
      :brand-color="brandColor"
      @ticket-created="onTicketCreated"
      @ticket-error="onTicketError"
    />
  </div>
</template>

<script>
import TicketWidget from './TicketWidget.vue'

export default {
  name: 'FloatingTicketWidget',
  components: {
    TicketWidget
  },
  props: {
    brandColor: {
      type: String,
      default: '#3b82f6'
    }
  },
  inject: {
    deepServiceDeskConfig: {
      from: 'deepServiceDeskConfig',
      default: () => ({})
    }
  },
  mounted() {
    // Escutar evento global para abrir o widget
    window.addEventListener('new-ticket', this.openWidget)
  },
  beforeDestroy() {
    window.removeEventListener('new-ticket', this.openWidget)
  },
  methods: {
    openWidget() {
      if (this.$refs.ticketWidget) {
        this.$refs.ticketWidget.openPopup()
      }
    },
    onTicketCreated(data) {
      // Emitir evento global para que a aplicação possa escutar
      window.dispatchEvent(new CustomEvent('ticket-created', { detail: data }))
      
      // Mostrar notificação de sucesso
      this.showNotification('Ticket criado com sucesso!', 'success')
    },
    onTicketError(error) {
      // Emitir evento global para que a aplicação possa escutar
      window.dispatchEvent(new CustomEvent('ticket-error', { detail: error }))
      
      // Mostrar notificação de erro
      this.showNotification(error.message || 'Erro ao criar ticket', 'error')
    },
    showNotification(message, type = 'info') {
      // Criar notificação toast simples
      const notification = document.createElement('div')
      notification.className = `deep-service-desk-notification ${type}`
      notification.textContent = message
      
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#3b82f6'};
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        font-size: 14px;
        font-weight: 500;
        max-width: 300px;
        word-wrap: break-word;
        animation: slideInRight 0.3s ease;
      `
      
      // Adicionar animação CSS
      if (!document.getElementById('deep-service-desk-notification-styles')) {
        const style = document.createElement('style')
        style.id = 'deep-service-desk-notification-styles'
        style.textContent = `
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOutRight {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `
        document.head.appendChild(style)
      }
      
      document.body.appendChild(notification)
      
      // Remover após 5 segundos
      setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease'
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification)
          }
        }, 300)
      }, 5000)
    }
  }
}
</script>

<style>
.floating-ticket-widget {
  /* Este componente não tem estilos visuais próprios */
  /* Ele apenas gerencia o widget de ticket */
}
</style> 